import { render, staticRenderFns } from "./FuseList.vue?vue&type=template&id=56396b98"
import script from "./FuseList.vue?vue&type=script&lang=js"
export * from "./FuseList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports